import { Group, Text } from "@mantine/core";

// TODO: clean up rem below
export function GuideRecommendationHeader({ guideTitle }: { guideTitle: string }) {
    return (
        <Group
            bg={"linear-gradient(90deg, #29446C 0%, #5C3D4E 100%)"}
            gap="xs"
            p="sm"
            styles={{ root: { borderTopLeftRadius: "1.25rem", borderTopRightRadius: "1.25rem" } }}
        >
            <Text size="sm">{`${guideTitle} call detected`}</Text>
        </Group>
    );
}
